__turbopack_context__.v({
  "container": "_4qrHeq_container",
  "containerDark": "_4qrHeq_containerDark",
  "containerLight": "_4qrHeq_containerLight",
  "dateContainer": "_4qrHeq_dateContainer",
  "dateStyle": "_4qrHeq_dateStyle",
  "dateStyleDark": "_4qrHeq_dateStyleDark",
  "dateStyles": "_4qrHeq_dateStyles",
  "imgStyles": "_4qrHeq_imgStyles",
  "imgWrapper": "_4qrHeq_imgWrapper",
  "marginBotton10": "_4qrHeq_marginBotton10",
  "marginBotton15": "_4qrHeq_marginBotton15",
  "marginBt10Larg": "_4qrHeq_marginBt10Larg",
  "marginTop20px": "_4qrHeq_marginTop20px",
  "tagStyleDark": "_4qrHeq_tagStyleDark",
  "tagStylesText1": "_4qrHeq_tagStylesText1",
  "tagStylesTextDark": "_4qrHeq_tagStylesTextDark",
  "timeDuration": "_4qrHeq_timeDuration",
  "titleStyles": "_4qrHeq_titleStyles",
  "titleStylesDark": "_4qrHeq_titleStylesDark",
  "verticalLline": "_4qrHeq_verticalLline",
  "videoDurationStyles": "_4qrHeq_videoDurationStyles",
});
